import { NumberParam, useQueryParam, withDefault } from 'use-query-params';

const EditedDomainParam = withDefault(NumberParam, null);
export const useEditedDomainId = () => {
  return useQueryParam('editedDomainId', EditedDomainParam);
};
